import { render } from "./InputSearchCatalogItem.vue?vue&type=template&id=b72235a2&scoped=true"
import script from "./InputSearchCatalogItem.vue?vue&type=script&lang=js"
export * from "./InputSearchCatalogItem.vue?vue&type=script&lang=js"

import "./InputSearchCatalogItem.vue?vue&type=style&index=0&id=b72235a2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72235a2"]])

export default __exports__